import { motion } from "framer-motion";
import React from "react";
import styled from "styled-components";

const Box = styled(motion.a)`
  width: 100%;
  text-decoration: none;
  min-height: 24rem;
  padding: 1rem;
  color: ${(props) => props.theme.text};
  border: 2px solid ${(props) => props.theme.text};
  backdrop-filter: blur(2px);
  box-shadow: 0 0 1rem 0 rgba(0, 0, 0, 0.2);
  cursor: pointer;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 5;

  &:hover {
    color: ${(props) => props.theme.body};
    background-color: ${(props) => props.theme.text};
    transition: all 0.3s ease;
  }
`;

const Image = styled.div`
  background-image: ${(props) => `url(${props.img})`};
  width: 100%;
  height: 160px;
  background-size: cover;
  border: 1px solid transparent;
  background-position: center center;
  border-radius: 8px;

  ${Box}:hover & {
    border: 1px solid ${(props) => props.theme.body};
  }
`;

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
`;

const Title = styled.h3`
  color: inherit;
  padding: 0.5rem 0;
  padding-top: 1rem;
  font-family: "Karla", sans-serif;
  font-weight: 700;
  font-size: calc(0.95rem + 0.2vw);
  line-height: 1.4;
  border-bottom: 1px solid ${(props) => props.theme.text};

  ${Box}:hover & {
    border-bottom: 1px solid ${(props) => props.theme.body};
  }
`;

const HashTags = styled.div`
  padding: 0.5rem 0;
  font-size: 0.85rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
`;

const Tag = styled.span`
  margin-right: 0.25rem;
`;

const Date = styled.span`
  padding-top: 0.5rem;
  font-size: 0.8rem;
  opacity: 0.8;
`;

const Container = styled(motion.div)`
  height: 100%;
`;

const Item = {
  hidden: {
    scale: 0,
  },
  show: {
    scale: 1,
    transition: {
      type: "spring",
      duration: 0.5,
    },
  },
};

const BlogComponent = (props) => {
  const { name, tags, date, imgSrc, link } = props.blog;
  return (
    <Container variants={Item}>
      <Box target="_blank" href={`${link}`}>
        <Image img={imgSrc} />
        <TextContent>
          <Title>{name}</Title>
          <div>
            <HashTags>
              {tags.map((t, id) => {
                return <Tag key={id}>#{t}</Tag>;
              })}
            </HashTags>
            <Date>{date}</Date>
          </div>
        </TextContent>
      </Box>
    </Container>
  );
};

export default BlogComponent;
